import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ProductItem extends Component {
	state = {
		item: this.props.item
	};
	render() {
		const { item } = this.state;
		return (
			<div className="product">
				<div className="prdct-img-details">
					<Link to={'/product/' + item.id}>
						<div className="prdct-img">
							<img src={item.image} alt="" />
						</div>
					</Link>
					<div className="details">
						<h6 className="title">{item.name}</h6>
						<div className="d-flex flex-row align-items-center justify-content-between py-1 mt-1">
							<p className="price m-0">₹{item.price}</p>
							<p className="qty-text m-0">1KG</p>
						</div>
						<div className="py-1 d-flex align-items-center justify-content-between">
							{!item.qty || item.qty === 0 ? (
								<button
									className="addBtn"
									onClick={() => {
										this.setState({ item: { ...item, qty: 1 } });
									}}
								>
									ADD
								</button>
							) : (
								<div className="d-flex align-items-center justify-content-between w-100">
									<button
										className="qtyBtn"
										onClick={() => {
											this.setState({ item: { ...item, qty: item.qty - 1 } });
										}}
									>
										<i className="fa fa-minus" />
									</button>
									<h1 className="m-0 qtyText">{item.qty}</h1>
									<button
										className="qtyBtn"
										onClick={() => {
											this.setState({ item: { ...item, qty: item.qty + 1 } });
										}}
									>
										<i className="fa fa-plus" />
									</button>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default ProductItem;
